/**
 * Records which model gallery (men / women) the shopper was looking at when they added a product to the
 * cart, as a hidden line item property: properties[_model] = men | women.
 *
 * Properties starting with "_" stay hidden in the cart and at checkout, but are saved on the order, so the
 * order confirmation email can show the matching photo (first image of custom.mens_gallery /
 * custom.womens_gallery). Products without model galleries get no property.
 *
 * - Product page: the model shown in the gallery (window.BWModelGallery, snippets/custom_pdp_gallery.liquid).
 * - Quick add from a product card: the card's model (data-mg-card-model, snippets/card-gallery.liquid),
 *   resolved the same way as assets/model-gallery-links.js.
 *
 * On the product page it also points the add-to-cart animation image (data-product-variant-media) at the
 * gallery's first photo, so a men's add flies the men's photo to the cart.
 *
 * Unisex products with a men's twin (custom.mens_product, map rendered as #bw-mens-variants by
 * layout/theme.liquid): in the men's view the form's variant id is swapped for the men's variant of the same
 * size, so the men's product (men's photo and title) is what reaches checkout and the order.
 */
(function () {
  var FIELD = 'properties[_model]';
  var FORMS = 'form[data-type="add-to-cart-form"]';
  var lastCardModel = null;
  var mensVariants = null;
  var unisexVariants = null;

  // Unisex variant id -> men's variant id, plus the reverse, from #bw-mens-variants (empty when absent).
  function loadVariantMaps() {
    if (mensVariants) return;
    mensVariants = {};
    unisexVariants = {};
    var data = document.getElementById('bw-mens-variants');
    if (!data) return;
    try {
      mensVariants = JSON.parse(data.textContent) || {};
    } catch (error) {
      mensVariants = {};
    }
    Object.keys(mensVariants).forEach(function (unisexId) {
      unisexVariants[mensVariants[unisexId]] = unisexId;
    });
  }

  function syncVariant(form, model) {
    loadVariantMaps();
    var input = form.querySelector('input[name="id"]');
    if (!input || !input.value) return;
    var unisexId = unisexVariants[input.value] || input.value;
    var wanted = model === 'men' && mensVariants[unisexId] ? mensVariants[unisexId] : unisexId;
    if (input.value !== wanted) input.value = wanted;
  }

  function pageModel() {
    return (window.BWModelGallery && window.BWModelGallery.model) || null;
  }

  function cardModel(card) {
    var marker = card.querySelector('[data-mg-card-model]');
    if (!marker) return null;
    var fromCollection = marker.getAttribute('data-mg-card-source') === 'collection';
    return (!fromCollection && pageModel()) || marker.getAttribute('data-mg-card-model');
  }

  function isPageProduct(form) {
    var section = form.closest('.shopify-section');
    return !form.closest('dialog') && !!section && !!section.querySelector('[data-mg-root]');
  }

  function modelFor(form) {
    return isPageProduct(form) ? pageModel() : lastCardModel;
  }

  function syncAnimationImage() {
    var image = document.querySelector('[data-mg-root] .pdp_gallery_grid img');
    if (!image || !image.getAttribute('src')) return;
    var src = image.getAttribute('src').replace(/([?&]width=)\d+/, '$1100');
    document.querySelectorAll('add-to-cart-component[data-product-variant-media]').forEach(function (button) {
      if (!button.closest('dialog')) button.setAttribute('data-product-variant-media', src);
    });
  }

  function sync() {
    syncAnimationImage();
    document.querySelectorAll(FORMS).forEach(function (form) {
      var model = modelFor(form);
      if (isPageProduct(form)) syncVariant(form, model);
      var input = form.querySelector('input[name="' + FIELD + '"]');

      if (model !== 'men' && model !== 'women') {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = FIELD;
        form.appendChild(input);
      }
      input.value = model;
    });
  }

  function onInteraction(event) {
    var card = event.target instanceof Element && event.target.closest('product-card');
    if (card) lastCardModel = cardModel(card);
    sync();
  }

  // The theme re-renders the form on variant changes, so the field is re-applied right before it is used.
  ['pointerdown', 'focusin', 'submit'].forEach(function (type) {
    document.addEventListener(type, onInteraction, true);
  });
  document.addEventListener('bw:model-change', sync);
  // The variant picker writes the unisex variant id back into the form after a size change.
  document.addEventListener('variant:update', function () {
    window.setTimeout(sync, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
